import { useFormik } from "formik";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { useLocation, useNavigate } from "react-router-dom";
import { useIsMobile } from "../../../../Utils/ResizeUtils";
import Cookies from "js-cookie";
import CommonToolbar from "../../../UIElements/CommonToolbar";
import { convertSumWithLatestCurrencyRate, formatCurrency, formatShortDate, measurementUnits, systemCurrencies, useEnumLabel } from "../../../../Utils/Utils";
import EnumsContext from "../../../../context/enums-context";
import useGetEnums from "../../../../Utils/EnumsUtils";

import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { TabMenu } from "primereact/tabmenu";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";

import commonStyle from "../../CommonStyles.module.css";
import ExternalProductSidebarPicker from "../../../UIElements/ExternalProductSidebarPicker";
import ProductsAndServicesPickerSidebar from "../../../UIElements/ProductsAndServicesPickerSidebar";
import { Guid } from "js-guid";
import { currencyEditor, dropdownEditor, numberEditor, textEditor } from "../../../../Utils/TableEditors";
import { SelectButton } from "primereact/selectbutton";
import useApi from "../../../../Utils/BackendClient";
import HistoryElement from "../../../UIElements/HistoryElement";
import DocumentArchiveTable from "../../../UIElements/DocumentArchiveTable";
import DocumentPrintSidebar from "../../../UIElements/DocumentPrintSidebar";
import DropdownInput from "../../../UIElements/Inputs/DropdownInput";
import CalendarInput from "../../../UIElements/Inputs/CalendarInput";
import DiscountInput from "../../../UIElements/Inputs/DiscountInput";
import ActNumberWithAutogenerateInput from "../../../UIElements/Inputs/ActNumberWithAutogenerateInput";
import CounterAgentCreationSidebar from "../../../UIElements/Sidebars/CounterAgentCreationSiidebar";
import { Tooltip } from "primereact/tooltip";
import TextInput from "../../../UIElements/Inputs/TextInput";

const ExternalActDetails = () => {

    const ctx = useContext(EnumsContext);
    const isMobile = useIsMobile();
    const location = useLocation();
    const navigate = useNavigate();
    const toast = useRef();

    const { createExternalAct, fetchExternalActDetails, fetchExternalActDocuments, fetchExternalActHistory, updateExternalAct } = useApi();

    const [actData, setActData] = useState({
        partner: null,
        client: null,
        partner_is_payment_receiver: false,
        commission_percent: 0,
        act_number: "",
        act_date: new Date(),
        pay_due_date: new Date(),
        division: null,
        act_number_autogenerate: true,
        comission_type: "%",
        products: [],
        services: [],
        discounts: [],
        commission: []
    });
    const [actHistory, setActHistory] = useState(null);
    const [cagentCreationSidebarVisible, setCagentCreationSidebarVisible] = useState(false);
    const [docArchive, setDocArchive] = useState(null);
    const [docArchiveLazyState, setDocArchiveLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1
    });
    const [docArchiveTotalRecords, setDocArchiveTotalRecords] = useState(0);
    const [exSbVisible, setExSbVisible] = useState(false);
    const [historyLazyState, setHistoryLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1
    });
    const [historyTotalRecords, setHistoryTotalRecords] = useState(0);
    const [isClient, setIsClient] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isFinalized, setIsFinalized] = useState(false);
    const [printDocuments, setPrintDocuments] = useState(false);
    const [selectedElement, setSelectedElement] = useState(null);
    const [tooltipValue, setTooltipValue] = useState("");
    const [submitLoading, setSubmitLoading] = useState(false);
    const [tabShowed, setTabShowed] = useState(0);
    const [totaLActSum, setTotalActSum] = useState(0);
    const [visible, setVisible] = useState(false);

    const enumTypes = useMemo(() => ["divisions", "clients", "partners", "pay_statuses"], []);

    useGetEnums(enumTypes);

    const getPayStatusLabel = useEnumLabel(ctx.enums.pay_statuses.data);

    useEffect(() => {
        if (location.state) {
            if (location.state.id) {
                setIsEdit(true);
                const getActDetails = async () => {
                    const response = await fetchExternalActDetails(location.state.id);

                    console.log(response.data);

                    if (response.status === 200) {
                        response.data.act_date = new Date(response.data.act_date);
                        response.data.pay_due_date = new Date(response.data.pay_due_date);

                        if (response.data.commission && response.data.commission.length > 0) {
                            response.data.comission_type = "$";

                            response.data.commission.forEach(obj => {
                                delete obj.amountUAH;
                            });
                        }
                        else {
                            response.data.comission_type = "%";
                        }

                        if (response.data.discounts && response.data.discounts.length > 0) {
                            response.data.discounts.forEach(obj => {
                                delete obj.amountUAH;
                            });
                        }

                        response.data.commission_percent = response.data.commission_percent * 100;

                        response.data.products.forEach(product => {
                            if (!product.measurement_unit) {
                                product.measurement_unit = "PIECES";
                            }

                            product.feId = Guid.newGuid().toString();
                        });

                        setActData(response.data);

                        if (response.data.status === "FINALIZED") {
                            setIsFinalized(true);
                        }
                    }
                    else {
                        toast.current.show({ severity: "error", summary: "Помилка отримання даних акту", detail: "Дані акту не отримано. Код помилки: " + response.status, life: 3000 });
                    }
                }

                getActDetails();
            }
            else if (location.state.items) {
                const newData = {
                    partner: null,
                    client: null,
                    partner_is_payment_receiver: false,
                    commission_percent: 0,
                    agreement_number: null,
                    act_number: "",
                    act_date: new Date(),
                    pay_due_date: new Date(),
                    division: Cookies.get("division"),
                    act_number_autogenerate: true,
                    comission_type: "%",
                    products: [],
                    services: [],
                    discounts: [],
                    commission: []
                };

                const updatedItems = location.state.items.map(item => ({
                    ...item,
                    total_quantity: item.quantity,
                    quantity: 0,
                    description: item.name,
                }));

                newData.partner = location.state.items[0].cagent_id;

                newData.products = updatedItems;

                setActData(newData);
            }
        }

    }, [fetchExternalActDetails, location.state]);


    const formik = useFormik({
        initialValues: actData,
        enableReinitialize: true,
        onSubmit: async (values) => {

            setSubmitLoading(true);

            const payload = {
                ...values,
                act_date: formatShortDate(values.act_date),
                pay_due_date: formatShortDate(values.pay_due_date),
                commission_percent: values.commission_percent !== 0 ? values.commission_percent / 100 : values.commission_percent,
                commission: values.commission.length > 0 ? values.commission : [],
            };

            if (values.products.length > 0) {
                const newProducts = values.products.map(product => ({
                    ...product,
                    priceUAH: convertSumWithLatestCurrencyRate(product.currency, product.price)
                }));

                payload.products = newProducts;
            }

            if (values.services.length > 0) {
                const newServices = values.services.map(service => ({
                    ...service,
                    priceUAH: convertSumWithLatestCurrencyRate(service.currency, service.price)
                }));

                payload.services = newServices;
            }

            if (values.discounts.length > 0) {
                var nonZeroDiscounts = values.discounts.filter(discount => discount.amount !== 0);

                nonZeroDiscounts = nonZeroDiscounts.map(discount => ({
                    ...discount,
                    amountUAH: convertSumWithLatestCurrencyRate(discount.currency, discount.amount)
                }));

                payload.discounts = nonZeroDiscounts;
            }

            const response = isEdit ? await updateExternalAct(payload.id, payload) : await createExternalAct(payload);

            const successStatus = isEdit ? 200 : 201

            setSubmitLoading(false);

            if (response.status === successStatus) {
                const toastMessage = isEdit ? { severity: "success", summary: "Успіх редагування", detail: "Акт успішно відредаговано", life: 3000 }
                    : { severity: "success", summary: "Успіх створення", detail: "Акт успішно створено", life: 3000 };

                navigate("/externalacts", { state: { toast: toastMessage } });
            }
            else {
                toast.current.show({ severity: "error", summary: isEdit ? "Помилка редагування" : "Помилка створення", detail: "Акт не " + (isEdit ? "відредаговано" : "створено") + ". Код помилки: " + response.status, life: 3000 });
            }
        }
    });

    useEffect(() => {
        let calcAmount = 0;

        if (formik.values?.products?.length > 0) {
            calcAmount += formik.values.products.reduce((sum, prod) => sum + convertSumWithLatestCurrencyRate(prod.currency, (prod.quantity ?? 1) * prod.price), 0);
        }

        if (formik.values?.services?.length > 0) {
            calcAmount += formik.values.services.reduce((sum, prod) => sum + convertSumWithLatestCurrencyRate(prod.currency, prod.price), 0);
        }

        if (formik.values?.discounts?.length > 0) {
            calcAmount -= formik.values.discounts.reduce((sum, disc) => sum + convertSumWithLatestCurrencyRate(disc.currency, Number(disc.amount)), 0);
        }

        setTotalActSum(calcAmount);

    }, [formik.values.products, formik.values.services, formik.values.discounts]);

    const confirmLeave = (event) => {

        if (formik.values !== actData) {

            confirmDialog({
                group: 'headless',
                header: 'Незбережені зміни',
                message: 'У вас є незбережені зміни. Ви впевнені, що хочете залишити цю сторінку?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: "Так",
                rejectLabel: "Hi",
                defaultFocus: 'accept',
                accept: () => { navigate("/externalacts", { state: { pageState: location?.state?.pageState } }) }
            });

        }
        else {
            navigate("/externalacts", { state: { pageState: location?.state?.pageState } });
        }
    }

    const getExternalActHistory = async (id, state) => {

        const response = await fetchExternalActHistory(id, state);

        if (response.status === 200) {
            setActHistory(response.data.results);
            setHistoryTotalRecords(response.data.count);
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка отримання історії", detail: "Помилка сервера " + response.status, life: 3000 });
        }
    }

    const getDocumentsArchive = async (id, lazyState) => {

        const response = await fetchExternalActDocuments(id, lazyState);

        if (response.status === 200) {
            setDocArchive(response.data.results);
            setDocArchiveTotalRecords(response.data.count);
        }
    }

    const onHistoryPage = (event) => {
        event.page = event.page + 1;
        getExternalActHistory(location.state.id, event);

        setHistoryLazyState(event);
    }

    const onDocArchivePage = (event) => {
        event.page = event.page + 1;
        getDocumentsArchive(location.state.id, event);

        setDocArchiveLazyState(event);
    }

    const AddProductToTable = () => {
        const product = {
            feId: Guid.newGuid().toString(),
            quantity: 1,
            measurement_unit: "PIECES",
            description: null,
            price: 0,
            currency: "UAH",
            priceUAH: 0
        }

        const updatedItems = [...formik.values.products, product];

        formik.setFieldValue("products", updatedItems);
    }

    const AddServiceToTable = () => {
        const service = {
            feId: Guid.newGuid().toString(),
            description: null,
            price: 0,
            currency: "UAH",
            priceUAH: 0
        }

        const updatedItems = [...formik.values.services, service];

        formik.setFieldValue("services", updatedItems);
    }

    const ExternalProductSelectionHandler = (product) => {

        const sp = selectedElement;
        sp.description = product.name;
        sp.price = product.price;
        sp.currency = product.currency;
        sp.measurement_unit = product.measurement_units;
        sp.total_quantity = product.quantity;

        const newProducts = formik.values.products.map(item =>
            item.feId === sp.feId ? sp : item
        );

        formik.setFieldValue("products", newProducts);

        setExSbVisible(false);
    }

    const DeleteItemFromTable = (rowData, type) => {

        const updatedItems = formik.values[type].filter(item => item.feId !== rowData.feId);

        formik.setFieldValue(type, updatedItems);
    };

    const SelectionHandler = (service) => {
        const sp = selectedElement;
        sp.description = service.name;
        sp.price = service.price;
        sp.currency = service.currency;

        const newService = formik.values.services.map(item =>
            item.feId === sp.feId ? sp : item
        );

        formik.setFieldValue("services", newService);

        setVisible(false);
    }

    const printDocumentHandler = () => {
        setPrintDocuments(true);
    }

    const CheckAndChangeComissionType = (type) => {
        if (type === "%") {
            formik.setFieldValue("comission_type", type);
        }
        else {
            if (formik.values.commission.length === 0) {
                let updatedComissionList = formik.values.commission;

                const newComission = {
                    currency: "UAH",
                    amount: 0
                }

                updatedComissionList = [...updatedComissionList, newComission];

                formik.setFieldValue("commission", updatedComissionList);
            }

            formik.setFieldValue("comission_type", type);
        }
    }

    const handleParameterChange = (index, value, parameter, array) => {
        const obj = [...formik.values[array]];
        obj[index][parameter] = value;
        formik.setFieldValue(array, obj);
    };

    const toolbarLeftData = () => {

        let name = "Створення нового партнерського акту";

        if (isEdit) {
            name = `Редагування партнерського акту №${actData?.act_number}`

            if (isFinalized) {
                name = "Інформація про партнерський акт"
            }
        }

        return <h3>{name}</h3>
    }

    const HandleCagentCreation = async (id) => {
        if (isClient) {
            formik.setFieldValue("client", id);
        }
        else {
            formik.setFieldValue("partner", id);
        }
    }

    const handleCellEditComplete = (e, arrayName) => {
        const rowIndex = e.index ?? e.rowIndex;
        const path = `${arrayName}[${rowIndex}].${e.field}`;

        formik.setFieldValue(path, e.newValue);
    };

    const items = [
        {
            label: 'Деталі акту',
            icon: 'pi pi-book',
            command: () => {
                setTabShowed(0);
            },
        },
        ...(isFinalized
            ? [
                {
                    label: 'Платежі',
                    icon: 'pi pi-money-bill',
                    command: () => {
                        setTabShowed(1);
                        //getSaleActPayments(location.state.id);
                    },
                },
            ]
            : []),
        ...(isEdit
            ? [
                {
                    label: 'Історія',
                    icon: 'pi pi-history',
                    command: () => {
                        setTabShowed(2);
                        getExternalActHistory(location.state.id, historyLazyState);
                    },
                },
                {
                    label: 'Документи',
                    icon: 'pi pi-save',
                    command: () => {
                        setTabShowed(3);
                        getDocumentsArchive(location.state.id, docArchiveLazyState);
                    },
                },
            ]
            : []),
    ];

    const contentToolbarRightTemplate = () => {
        return (<>
            <div className="flex flex-wrap gap-2">
                <Button label="Товар" icon="pi pi-plus" severity="success" className={commonStyle.addButton} type="button" onClick={() => AddProductToTable()} />
                <Button label="Послугу" icon="pi pi-plus" severity="success" className={commonStyle.addButton} type="button" onClick={() => AddServiceToTable()} />
            </div>
        </>);
    }

    const setTableHeader = (tablename) => {
        return (
            <div className="flex flex-wrap align-items-center justify-content-between gap-2">
                <span className={!isMobile ? "text-xl text-900 font-bold" : "font-bold"}>{tablename}</span>
            </div>
        );
    }

    const tableActionBodyTemplate = (rowData, type) => {

        return (isFinalized ? <></> : <div className="flex flex-row gap-2 justify-content-center align-items-center">
            <Button
                icon="pi pi-shopping-cart"
                type="button"
                outlined
                rounded
                severity="warning"
                tooltip={`${type === "products" ? "Зовнішній товар" : "Послуга"}`}
                tooltipOptions={{ showOnDisabled: true, position: "left" }}
                onClick={() => {
                    type === "products" ? setExSbVisible(true) : setVisible(true);
                    setSelectedElement(rowData);
                }}
            />
            <Button
                icon="pi pi-trash"
                type="button"
                outlined
                rounded
                severity="danger"
                tooltip="Видалити"
                tooltipOptions={{ showOnDisabled: true, position: "left" }}
                onClick={() => DeleteItemFromTable(rowData, type)}
            />
        </div>
        );
    }

    const priceTemplate = (rowData) => {

        const totalAmount = rowData.price * rowData.quantity;
        const convertedPriceAmount = formatCurrency(totalAmount, rowData.currency);
        if (rowData.currency === "UAH") {
            return convertedPriceAmount;
        }
        else {
            return <div className="flex flex-column">
                <div>{convertedPriceAmount}</div>
                <div className="text-sm" style={{ opacity: 0.8 }}>{`(${formatCurrency(convertSumWithLatestCurrencyRate(rowData.currency, totalAmount), "UAH")})`}</div>
            </div>;
        }
    }
    const CellBodyWithCopy = (rowData) => (
        <span
            className="copy-tooltip"
            data-value={rowData.description}
            tooltipOptions={{ position: 'top' }}
            onMouseDown={(e) => e.preventDefault()}
        >
            {rowData.description}
        </span>
    );

    return (
        <form onSubmit={formik.handleSubmit}
            onKeyDown={(e) => {
                if (e.key === 'Enter' && e.target.tagName !== "TEXTAREA") {
                    e.preventDefault();
                }
            }}>
            <Toast ref={toast} />
            <Tooltip
                target=".copy-tooltip"
                autoHide={false}
                appendTo={document.body}
                position="top"
                onShow={(e) => {
                    setTooltipValue(e.target.dataset.value);
                }}
            >
                <div className="flex align-items-center gap-2">
                    <Button
                        type="button"
                        icon="pi pi-copy"
                        outlined 
                        severity="secondary"
                        size="small"
                        className="bg-gray-100"
                        onClick={() => {
                            navigator.clipboard.writeText(tooltipValue);
                        }}
                    />
                </div>
            </Tooltip>
            <CommonToolbar isMobile={isMobile} isFinalized={isFinalized} loading={submitLoading} onRetunButtonClick={(event) => confirmLeave(event)} leftContent={toolbarLeftData()} onDocPrint={isEdit ? printDocumentHandler : null} />
            <ConfirmDialog group="headless" />
            <TabMenu model={items} />
            {tabShowed === 0 && <div className="grid">
                <div className={`${!isMobile ? commonStyle.leftMenu : commonStyle.mobileActDetailsMenu} ${isMobile ? "col-12 flex flex-column align-items-center" : "col-3"}`}>
                    <DropdownInput
                        formik={formik}
                        paramName={"division"}
                        context={ctx.enums.divisions.data}
                        onChange={(val) => formik.setFieldValue("division", val)}
                        label={"Точка продажу"}
                        isDisabled={isFinalized}
                        isMobile={isMobile}
                        mandatory />
                    <DropdownInput
                        formik={formik}
                        paramName={"partner"}
                        context={ctx.enums.partners.data}
                        onChange={(val) => formik.setFieldValue("partner", val)}
                        label={"Партнер"}
                        isDisabled={isFinalized}
                        isMobile={isMobile}
                        addButton={true}
                        addButtonTooltip={"Додати партнера"}
                        addButtonAction={() => {
                            setIsClient(false);
                            setCagentCreationSidebarVisible(true)
                        }}
                        mandatory />
                    <DropdownInput
                        formik={formik}
                        paramName={"client"}
                        context={ctx.enums.clients.data}
                        onChange={(val) => formik.setFieldValue("client", val)}
                        label={"Клієнт"}
                        isDisabled={isFinalized}
                        isMobile={isMobile}
                        addButton={true}
                        addButtonTooltip={"Додати клієнта"}
                        addButtonAction={() => {
                            setIsClient(true)
                            setCagentCreationSidebarVisible(true)
                        }} />
                    <TextInput formik={formik} paramName={"agreement_number"} label={"Номер договору"} isDisabled={isFinalized} isMobile={isMobile}/>
                    <CalendarInput formik={formik} paramName={"act_date"} label={"Дата акту"} isDisabled={isFinalized} isMobile={isMobile} />
                    <CalendarInput formik={formik} paramName={"pay_due_date"} label={"Очікувана дата оплати"} isDisabled={isFinalized} isMobile={isMobile} />
                    <div className={`${commonStyle.formInput} mt-1`}>
                        {formik.values.commission_percent !== undefined &&
                            !isNaN(formik.values.commission_percent) && (
                                <label className={`${commonStyle.pseudoFloatLabel} ml-3`}>Комісія</label>
                            )}
                        <div className={`p-inputgroup flex-1 mt-1`}>
                            <SelectButton value={formik.values.comission_type} disabled={isFinalized} onChange={(e) => CheckAndChangeComissionType(e.value)} options={["%", "$"]} />
                            {formik.values.comission_type === "%" ?
                                <InputText
                                    placeholder="Комісія"
                                    value={formik.values.commission_percent}
                                    onChange={e => formik.setFieldValue("commission_percent", e.target.value)}
                                /> :
                                <InputText placeholder="Комісія" disabled />
                            }
                        </div>
                    </div>
                    {formik.values.comission_type === "$" && formik.values.commission.map((currencyAmount, index) => (
                        <div key={index} className={`${commonStyle.formInput} ${commonStyle.marginBottom} ${!isMobile ? "" : "w-11"}`}>
                            <div className="p-inputgroup flex-1">
                                <span className={`${commonStyle.currencySpan} p-inputgroup-addon`}>
                                    <Dropdown
                                        disabled={isFinalized}
                                        className={`${commonStyle.currencyDropDown} w-full`}
                                        value={currencyAmount.currency}
                                        onChange={e => handleParameterChange(index, e.value, "currency", "commission")}
                                        options={systemCurrencies}
                                    />
                                </span>
                                <InputText
                                    onChange={e => handleParameterChange(index, e.target.value, "amount", "commission")}
                                    disabled={isFinalized}
                                    name="amount"
                                    value={currencyAmount.amount}
                                    className={formik.errors.price && formik.touched.price ? 'p-invalid' : ''}
                                />
                                {formik.errors.price && formik.touched.price && (<small className={commonStyle.errorSmall}>{formik.errors.price}</small>)}
                            </div>
                        </div>))
                    }
                    <DiscountInput formik={formik} paramName={"discounts"} isDisabled={isFinalized} isMobile={isMobile} />
                    <ActNumberWithAutogenerateInput formik={formik} showAutogenerate={!isEdit} isDisabled={isFinalized} />
                    <div className={commonStyle.checkBoxInput}>
                        <div className={`${commonStyle.checkboxStyle} p-inputgroup flex-1 md:w-22rem"`}>
                            <Checkbox
                                name="partner_is_payment_receiver"
                                onChange={(e) => { formik.setFieldValue('partner_is_payment_receiver', !formik.values.partner_is_payment_receiver) }}
                                checked={formik.values.partner_is_payment_receiver}
                                disabled={isFinalized}
                            />
                            <label>Партнер отримує оплату</label>
                        </div>
                    </div>
                    {formik.values.status && <div className={`${commonStyle.formInput} ${!isMobile ? "" : "w-11"}`}>
                        <div className="p-inputgroup flex-column">
                            <FloatLabel>
                                <InputText value={formik.values.status === "FINALIZED" ? "Фіналізований" : "Драфт"}
                                    disabled
                                    className="w-full" />
                                <label>Статус</label>
                            </FloatLabel>
                        </div>
                    </div>}
                    {formik.values.pay_status && <div className={`${commonStyle.formInput} ${!isMobile ? "" : "w-11"}`}>
                        <div className="p-inputgroup flex-column">
                            <FloatLabel>
                                <InputText value={getPayStatusLabel(formik.values.pay_status)}
                                    disabled
                                    className="w-full" />
                                <label>Статус оплати</label>
                            </FloatLabel>
                        </div>
                    </div>}
                </div>
                <div className={`${isMobile ? "col-12" : "col-7 md:col-8 lg:col-9"}`}>
                    {!isFinalized && <Toolbar className="mb-4" end={contentToolbarRightTemplate} />}
                    {(!isMobile && formik.values.products.length > 0) && <DataTable value={formik.values.products} header={setTableHeader("Товари")}
                        dataKey="id" editMode="cell">
                        <Column field="description" header="Назва товару"
                            editor={(options) => textEditor(options)} onCellEditComplete={(e) => handleCellEditComplete(e, "products")} body={CellBodyWithCopy} style={{ width: '30%' }} />
                        <Column field="quantity" header="Кількість"
                            editor={(options) => numberEditor(options, options.rowData.measurement_unit === "PIECES" ? 0 : 2)} onCellEditComplete={(e) => handleCellEditComplete(e, "products")} style={{ width: '5%' }} />
                        <Column field="measurement_unit" header="Од. виміру"
                            editor={(options) => dropdownEditor(options)} body={rowData => measurementUnits.find(unit => unit.value === rowData.measurement_unit).shortName} onCellEditComplete={(e) => handleCellEditComplete(e, "products")} />
                        <Column field="price" header="Ціна за одиницю"
                            editor={(options) => numberEditor(options, 2)} body={(rowdata) => formatCurrency(rowdata.price, rowdata.currency)} onCellEditComplete={(e) => handleCellEditComplete(e, "products")} style={{ width: '15%' }} />
                        <Column field="currency" header="Валюта"
                            editor={(options) => currencyEditor(options)} onCellEditComplete={(e) => handleCellEditComplete(e, "products")} style={{ width: '10%' }} />
                        <Column field="priceUAH" header="Ціна за одиницю, грн" body={(rowdata) => formatCurrency(convertSumWithLatestCurrencyRate(rowdata.currency, rowdata.price), "UAH")} style={{ width: '15%' }} />
                        <Column field="totalPrice" header="Загальна ціна, грн" body={priceTemplate} />
                        <Column field="action" body={(rowData) => tableActionBodyTemplate(rowData, "products")} style={{ width: '15%' }} />
                    </DataTable>}
                    {(!isMobile && formik.values.services.length > 0) && <DataTable value={formik.values.services} header={setTableHeader("Послуги")} dataKey="id" editMode="cell">
                        <Column field="description" header="Назва послуги" editor={(options) => textEditor(options)} onCellEditComplete={(e) => handleCellEditComplete(e, "services")} style={{ width: '45%' }} />
                        <Column field="price" header="Ціна за одиницю"
                            editor={(options) => numberEditor(options, 2)} body={(rowdata) => formatCurrency(rowdata.price, rowdata.currency)} onCellEditComplete={(e) => handleCellEditComplete(e, "services")} style={{ width: '15%' }} />
                        <Column field="currency" header="Валюта"
                            editor={(options) => currencyEditor(options)} onCellEditComplete={(e) => handleCellEditComplete(e, "services")} style={{ width: '10%' }} />
                        <Column field="priceUAH" header="Ціна за одиницю, грн" body={(rowdata) => formatCurrency(convertSumWithLatestCurrencyRate(rowdata.currency, rowdata.price), "UAH")} style={{ width: '15%' }} />
                        <Column field="action" body={(rowData) => tableActionBodyTemplate(rowData, "services")} style={{ width: '15%' }} />
                    </DataTable>}
                    {(formik.values.products.length > 0 || formik.values.services.length > 0) && <div className={commonStyle.footerContainer}>
                        <h3>Загальна сума акту: {formatCurrency(totaLActSum, "UAH")}</h3>
                    </div>}
                </div>
            </div>}
            {tabShowed === 2 && <HistoryElement data={actHistory} lazyState={historyLazyState} totalRecords={historyTotalRecords} onHistoryPage={onHistoryPage} isAct={true} />}
            {tabShowed === 3 && <DocumentArchiveTable documents={docArchive} lazyState={docArchiveLazyState} onPage={onDocArchivePage} totalRecords={docArchiveTotalRecords} toast={toast} />}
            <ProductsAndServicesPickerSidebar sbVisible={visible} onHide={() => setVisible(false)} type={"services"} onSelect={SelectionHandler} />
            <ExternalProductSidebarPicker sbVisible={exSbVisible} onHide={() => setExSbVisible(false)} context={ctx} onSelect={ExternalProductSelectionHandler} toast={toast} cagent={formik.values?.partner} />
            <DocumentPrintSidebar sbVisible={printDocuments} onHide={() => setPrintDocuments(false)} actData={actData} toast={toast} />
            <CounterAgentCreationSidebar visible={cagentCreationSidebarVisible} onHide={() => setCagentCreationSidebarVisible(false)} toast={toast}
                ctx={ctx} key={location.pathname} onCreate={(id) => HandleCagentCreation(id)} isClient={isClient} isPartner={!isClient} />
        </form>
    );
}

export default ExternalActDetails;